import { Decodable } from './_decodable';
import { Client } from './client';
import { QuoteItem } from './quote-item';

export interface QuoteProposal {
  id: number;
  token: string;
  proposalNumber?: string;
  shortDescription?: string;
}

class Quote extends Decodable {
  static readonly CREATED_ONLY = 1;
  static readonly SENT = 2;
  static readonly APROVED = 3;
  static readonly REFUSED = 4;
  static readonly BILLED = 5;
  static readonly PAYED = 6;
  static readonly DEFAULT_VALUE = 0;
  static readonly EXPIRED = 7;

  id?: number;
  clientId?: number;
  status?: number;
  name?: string;
  description?: string;
  email?: string;
  phone?: string;
  city?: string;
  state?: string;
  cep?: string;
  neighborhood?: string;
  address?: string;
  addressNumber?: string;
  addressComplement?: string;
  statusName?: string;
  statusClass?: string;
  items?: QuoteItem[];
  client?: Client;
  createdAt?: Date;
  updatedAt?: Date;

  requisitadaEm?: string;
  origin?: string; // Origem do lead (título do ShareLink)

  pendingAlert?: boolean;
  pendingDays?: number;
  pendingAlertText?: string;

  proposal?: QuoteProposal; // Proposta vinculada (se existir)

  protected _map = {
    createdAt: (e) => this.parseDate(e),
    updatedAt: (e) => this.parseDate(e),
    items: (e) => QuoteItem.parse(e),
    client: (e) => Client.parse(e),
    pendingAlert: (e) => !!e,
    proposal: (e) => e ? {
      id: e.id,
      token: e.token,
      proposalNumber: e.proposal_number,
      shortDescription: e.short_description,
    } : null,
  };
}

export { Quote };
